import { supabase } from '@/lib/supabase/client';
import type { Tables } from '@/lib/supabase/types';

export type ReactionRow = Tables<'reactions'>;
export type ReactionKind = 'agree' | 'question' | 'important';
export type TargetType = 'annotation' | 'reply' | 'document';

export interface ReactionSummary {
  kind: ReactionKind;
  count: number;
  isOwn: boolean;
}

export async function getReactionSummary(
  targetType: TargetType,
  targetId: string,
): Promise<ReactionSummary[]> {
  const [{ data, error }, { data: { user } }] = await Promise.all([
    supabase
      .from('reactions')
      .select('kind, author_id')
      .eq('target_type', targetType)
      .eq('target_id', targetId),
    supabase.auth.getUser(),
  ]);

  if (error) throw error;

  const userId = user?.id;
  const kinds: ReactionKind[] = ['agree', 'question', 'important'];
  const rows = data ?? [];

  return kinds.map(kind => ({
    kind,
    count: rows.filter(r => r.kind === kind).length,
    isOwn: rows.some(r => r.kind === kind && r.author_id === userId),
  }));
}

export async function toggleReaction(
  targetType: TargetType,
  targetId: string,
  kind: ReactionKind,
): Promise<boolean> {
  const { data, error } = await supabase.rpc('toggle_reaction', {
    p_target_type: targetType,
    p_target_id: targetId,
    p_kind: kind,
  });

  if (error) throw error;
  return data as boolean;
}
